import React, { useContext } from 'react';

var MenuContext = /*#__PURE__*/React.createContext({
  getItemProps: function getItemProps() {
    return {};
  },
  activeIndex: null,
  setActiveIndex: function setActiveIndex() {},
  setHasFocusInside: function setHasFocusInside() {},
  isOpen: false,
  disableCloseOnClickInside: false
});
var useMenuContext = function useMenuContext() {
  var context = useContext(MenuContext);
  if (!context) {
    throw new Error('The context of the menu should be only used inside menu');
  }
  return context;
};

export { MenuContext, useMenuContext };
